import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import {
  primaryColor, secondaryFont, wLight, maxMobile,
  maxWidth,
  retina,
  maxTablet,
  minExtraLargeScreen,
} from '../../../Utils/utilsStyle';
import GreenArrowIcon from '../../common/assets/svgIcons/GreenArrowIcon';
import IconButton from '../../common/components/IconButton';
import { isSalesforce } from 'Utils/UtilityFunctions';

type Props = {
  leftHeading: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  isShowAllHidden?: boolean;
  inGlobalSearch?: boolean;
  onSeelessClick?: (e: React.MouseEvent) => void;
  isDetailedSearch?: boolean;
} & typeof defaultProps;

const defaultProps = {
  isShowAllHidden: true,
  inGlobalSearch: false,
};
const Wrapper = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  &.searchHeadings {
    margin: 16px 0px 8px 0px;
    @media all and (min-width: ${minExtraLargeScreen}) {
    margin: 24px 0px 6px 0px;
    }
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin: 16px 0px 8px 0px;
    }
    @media all and (max-width: ${maxTablet}) {
      margin: 16px 0px 8px 0px;
    }
    @media all and (max-width: ${maxMobile}) {
      margin: 16px 0px 8px 0px;
    }
  }
  
  .show-all-style{
    color:${primaryColor};
    font-family: ${secondaryFont};
    font-weight: ${wLight};
    font-size: 14px;
    line-height:36px;
  }
  .horizontallyAligned{
    display:flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }
  .hidden{
    opacity:0;
  }
  .margin-left-8{
    margin-left:8px;
  }
 

`;
const HeadingWithShowAll = function HeadingWithShowAll(props: Props) {
  const {
    leftHeading, onClick, isShowAllHidden, inGlobalSearch, onSeelessClick, isDetailedSearch,
  } = props;

  return (
    <Wrapper className={classNames({
      searchHeadings: inGlobalSearch,
    })}
    >
      {leftHeading}
      <div className="horizontallyAligned">
        {isDetailedSearch ? (
          <IconButton
            Icon={GreenArrowIcon}
            title="See Less"
            onButtonClick={onSeelessClick}
            rightIcon
          />
        ) : (
          !isShowAllHidden && (
            <IconButton
              Icon={GreenArrowIcon}
              title="See More"
              onButtonClick={onClick}
              rightIcon
            />
          )
        )}
      </div>

    </Wrapper>
  );
};
HeadingWithShowAll.defaultProps = {
  isShowAllHidden: false,
  inGlobalSearch: false,
  onClick() { },
  onSeelessClick: () => { },
  isDetailedSearch: false,
};
export default HeadingWithShowAll;
